/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLayoutJustifyCenterV = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 22H2v-2h20zm0-18H2V2h20zm-3 15H5v-6h14zm0-8H5V5h14zm-2 6v-2H7v2zm0-8V7H7v2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLayoutJustifyCenterV as LayoutJustifyCenterV };
